import Auth0Lock from 'auth0-lock';
import EventEmitter from 'eventemitter3';
import decode from 'jwt-decode';
import Router from 'vue-router';
import { AUTH_CONFIG } from './auth0-variables';

export default class AuthService {
  authenticated = this.isAuthenticated()
  admin = this.isAdmin()
  authNotifier = new EventEmitter()
  userProfile;
  router = new Router()

  constructor() {
      // Add callback Lock's `authenticated` event
      this.lock.on('authenticated', this.setSession.bind(this));
      // Add callback for Lock's `authorization_error` event
      this.lock.on('authorization_error', function (err) {
          console.log(err);
          this.show({
              flashMessage: {
                  type: 'error',
                  text: err.errorDescription,
              },
          });
      });
      this.lock.on('unrecoverable_error', error => console.log(error));
      this.lock.on('signup error', function (err) {
          console.log(err);
          // this.hide();
          // this.show({
          //     flashMessage: {
          //         type: 'error',
          //         text: 'you suck!',
          //     },
          // });
      });
      this.lock.on('hide', function () {
          console.log("hidden lock");
          location.reload();
          // this.hide();
          // this.show({
          //     flashMessage: {
          //         type: 'error',
          //         text: 'you suck!',
          //     },
          // });
      });
      this.login = this.login.bind(this);
      this.setSession = this.setSession.bind(this);
      this.getAccessToken = this.getAccessToken.bind(this);
      this.getProfile = this.getProfile.bind(this);
      this.logout = this.logout.bind(this);
      this.fail = this.fail.bind(this);
      this.isAuthenticated = this.isAuthenticated.bind(this);
      this.getRole = this.getRole.bind(this);
      this.isAdmin = this.isAdmin.bind(this);
  }

  lock = new Auth0Lock(AUTH_CONFIG.clientId, AUTH_CONFIG.domain, {
      autoclose: false,
      loginAfterSignUp: false,
      mustAcceptTerms: true,
      auth: {
          audience: AUTH_CONFIG.apiUrl,
          responseType: 'token id_token',
          redirectUrl: AUTH_CONFIG.callbackUrl,
          params: {
              scope: 'openid profile email download:sample upload:samples download:samples',
          },
      },
      languageDictionary: {
          title: 'UnpacMe',
          success: {
              signUp: '<b>Thanks for signing up!</b><br>We have sent you a confirmation email. Once you confirm your email address we will activate your account.',
              logIn: 'Success!',
          },
          error: {
            signUp: {
                'lock.fallback': "please use a valid non-disposable email address",
            }
          },
          signUpTerms: 'By signing up, you agree to our <br><a target="_blank" href="https://www.unpac.me/tos">terms of service and privacy policy</a>.',
      },
      theme: {
          logo: '/static/img/unpacme_logo_black.png',
          primaryColor: 'black',
      },
      // additionalSignUpFields: [
      //     {
      //         name: 'reg_code',
      //         placeholder: 'enter your registration code',
      //         icon: '/static/img/arrow.png',
      //     }],
  });

  fail(error) {
      console.log('fail');
      console.log(error);
  }

  login() {
      // Call the show method to display the widget.
      console.log('attempting login');
      this.lock.show();
  }
  signUp() {
      // Call the show method to display the widget with sign up page
      this.lock.show({
          initialScreen: 'signUp',
          allowLogin: false,
      });
  }
  setSession(authResult) {
      if (authResult && authResult.accessToken && authResult.idToken) {
      // Set the time that the access token will expire at
          const expiresAt = JSON.stringify(
              authResult.expiresIn * 1000 + new Date().getTime(),
          );
          localStorage.setItem('access_token', authResult.accessToken);
          localStorage.setItem('id_token', authResult.idToken);
          localStorage.setItem('expires_at', expiresAt);
          this.authNotifier.emit('authChange', { authenticated: true, admin: this.isAdmin() });
          // navigate to the home route
          console.log('********** logged in');
          // Check if this is their first login (from the welcome page)
          // if it is then redirect them home else just reload to set
          // the gui for their token
          if (window.location.pathname.toLowerCase().includes('welcome')) {
              window.location.href = '/';
          } else {
              // window.location.href = '/';
              location.reload();
          }
      }
  }

  getAccessToken() {
      const accessToken = localStorage.getItem('access_token');
      if (!accessToken) {
          throw new Error('No access token found');
      }
      return accessToken;
  }

  getProfile(cb) {
      const accessToken = this.getAccessToken();
      const self = this;
      this.lock.getUserInfo(accessToken, (err, profile) => {
          if (profile) {
              self.userProfile = profile;
          }
          cb(err, profile);
      });
  }

  logout() {
      // Clear access token and ID token from local storage
      localStorage.removeItem('access_token');
      localStorage.removeItem('id_token');
      localStorage.removeItem('expires_at');
      this.userProfile = null;
      this.authNotifier.emit('authChange', false);
      // navigate to the home route
      console.log('********** logged out');
      window.location.href = '/';
  }

  isAuthenticated() {
      // Check whether the current time is past the
      // access token's expiry time
      const expiresAt = JSON.parse(localStorage.getItem('expires_at'));
      return new Date().getTime() < expiresAt;
  }

  getRole() {
      const namespace = 'https://example.com';
      const idToken = localStorage.getItem('id_token');
      if (idToken) {
          return decode(idToken)[`${namespace}/role`] || null;
      }
  }

  isAdmin() {
      return this.getRole() === 'admin';
  }
}



// WEBPACK FOOTER //
// ./src/auth/AuthService.js